import { Serializable } from '../../core/models/serializable';
export class LanguageProficiencyLevelModel
  implements Serializable<LanguageProficiencyLevelModel>
{
  fromObject(obj: any): LanguageProficiencyLevelModel {
    Object.assign(this, obj);

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public languageProficiencyLevelId: number;
  public name: string;
}
